import {FormView} from '@src/components/_views/configurable/FormView';
import {withRouterApi} from '@src/HOCs/withRouterApi';
import {FormViewProps} from '@src/@types/components/FormViewProps';
import ChecklistForm from './ChecklistForm';

export class ChecklistUpdateForm extends FormView {
    protected getFormComponent() {
        return ChecklistForm;
    }
}

export default ChecklistUpdateForm.getStoreConnector()(withRouterApi<FormViewProps>(ChecklistUpdateForm));
